import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f24b24c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f24b24c')) {
      api.createRecord('7f24b24c', component.options)
    } else {
      api.reload('7f24b24c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7f24b24c", function () {
      api.rerender('7f24b24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommended/components/collection-manage/index.vue"
export default component.exports